<template>
  <div>
    <section id="content">
      <div class="content-wrap">
        <div class="container clearfix">
        <router-link to="/esinistros/segmentos" class="text-center" style="display:flex; align-items:center;">
            <i
              class="icon-line-reply i-circled i-small"
              style="background-color: #2d88ff"
            ></i>
            Voltar
        </router-link>          
        <Tbheader
          :tipo="tipo + ' - imagens'"
          :novo="novo"
          :titulo="segmento.titulo"
          :icone="icone"
        />

          <div class="row">
            <div class="col-sm-6 offset-3 text-center">
              <label>Selecione as imagens</label>
            </div>
            <div class="col-12"></div>
            <div class="col-sm-12 text-center">
              <div
                class="areaFoto"
                :class="content.imagens ? 'ativo' : ''"
                @click="$refs.imagens.click()"
                :style="
                  content.imagens && carregado
                    ? 'background:url(' + content.imagens + ')'
                    : 'background:url()'
                "
              >
                <i class="icon-cloud-upload-alt"></i>
                <input
                  type="file"
                  @change="OnFileSelected"
                  id="imagens"
                  name="imagens"
                  ref="imagens"
                  style="display: none"
                  class="form-control"
                  accept="image/*"
                  multiple
                />
              </div>
            </div>
            <div class="col-sm-12" v-if="filesPreview.length > 0">
              <div class="row">
                <div class="col-sm-12">
                  <hr />
                  <h4 class="text-center">Pré-visualização</h4>
                </div>
                <div
                  class="col-sm-2 text-center"
                  v-for="(file, index) in filesPreview"
                  :key="index"
                >
                  <div
                    class="areaFoto"
                    :class="'ativo'"
                    :style="
                      carregado
                        ? 'background:url(' + file + ')'
                        : 'background:url()'
                    "
                  >
                    <i class="icon-cloud-upload-alt"></i>
                  </div>
                  <button
                    class="btn btn-danger"
                    @click.prevent="fnRemoveFotoPrev(index)"
                  >
                    Remover foto
                  </button>
                </div>
              </div>
            </div>
            <div class="col-sm-12" style="margin-top: 30px">
              <button
                class="btn btn-success"
                v-if="filesPreview.length > 0"
                style="width: 100%"
                @click.prevent="formSubmit()"
              >
                Enviar imagens
              </button>
            </div>

            <div class="col-sm-12" v-if="content.length > 0">
              <div class="row">
                <div class="col-sm-12">
                  <hr />
                  <h4 class="text-center">Fotos carregadas</h4>
                </div>
                <div
                  class="col-sm-2 text-center"
                  v-for="(file, index) in content"
                  :key="index"
                >
                  <div
                    class="areaFoto"
                    :class="'ativo'"
                    :style="'background:url(' + file.imagem + ')'"
                  >
                    <i class="icon-cloud-upload-alt"></i>
                  </div>
                  <button
                    class="btn btn-danger"
                    @click.prevent="fnRemoveFoto(index, file.imagemId)"
                  >
                    Remover foto
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- #content end -->
  </div>
</template>

<script>
import { getData, urlApi, getSuccess } from "../../global/utils";
import Tbheader from "../_headerTabelas";

export default {
  data: function () {
    return {
      stripe: true,
      tipo: "Incluindo",
      icone: "icon-line2-plus",
      colorAlert: "primary",
      titleAlert: "",
      activeAlert: false,
      content: [],
      files: [],
      filesPreview: [],
      filesContent: [],
      iconArea: 50 * 1,
      segmento: [],
      erro: "",
      urlApi: "esinistros/imagens",
      carregando: false,
      carregadoIm: false,
      deleteId: "",
      deleteAtivo: null,
      deleteTitulo: "",
    };
  },
    components: { Tbheader },

  mounted() {
    this.fnCarregaItems();
    this.fnCarregaSegmento();
  },
  methods: {
    OnFileSelected(event) {
      console.log(event.target.files.length);
      let imgUrl = null;
      let data = {};
      for (let index = 0; index < event.target.files.length; index++) {
        console.log(index);
        this.files.push(event.target.files[index]);
        this.filesPreview.push(URL.createObjectURL(event.target.files[index]));
        imgUrl = urlApi + "Upload/esinistros/segmentos/";
        data = {
          imagem: imgUrl + event.target.files[index].name,
          segmentoId: this.$route.params.id,
        };
        this.filesContent.push(data);
      }
      this.carregado = true;
    },
    async formSubmit() {
      let metodo = "post";
      for (let index = 0; index < this.filesContent.length; index++) {
        let data = await this.$http[metodo](
          "/esinistros/imagens",
          this.filesContent[index]
        )
          .then(() => {
            this.filesPreview.splice(index, 1);
          })
          .catch((e) => {
            return e;
          });
        this.error = data;
        if (index + 1 == this.filesContent.length) {
          this.OnUpload();
          this.filesPreview = [];
        }
      }
    },
    OnUpload() {
      var self = this;
      let fd = new FormData();
      for (var i = 0; i < this.files.length; i++) {
        let file = self.files[i];
        fd.append("files", file, file.name);
      }
      this.$http
        .post("esinistros/upload/esinistros/segmentos", fd)
        .then(() => {
          this.carregado = true;
          this.files = [];
          this.fnCarregaItems();
          getSuccess();
        });
    },
    fnRemoveFotoPrev(i) {
      this.filesPreview.splice(i, 1);
      this.files.splice(i, 1);
      this.filesContent.splice(i, 1);
    },
    fnRemoveFoto(i, id) {
      var filename = "";
      console.log(this.content[i].imagem);

      filename = this.content[i].imagem
        .split("/")
        .pop()
        .split("#")[0]
        .split("?")[0];
      this.$http.delete("esinistros/imagens/" + id).then((res) => {
        console.log(res);
        this.$http
          .delete(
            "esinistros/upload/esinistros/segmentos/" +
              filename +
              "/arquivo"
          )
          .then((res) => {
            console.log(res);
            this.fnCarregaItems();
          });
      });
    },
    async fnCarregaItems() {
      let data = await getData(this.urlApi + "/" + this.$route.params.id);
      this.content = data[0].content;
      this.carregando = false;
      this.carregadoIm = false;
      this.$vs.loading.close();
    },
    async fnCarregaSegmento() {
      let data = await getData("esinistros/segmentos/" + this.$route.params.id);
      this.segmento = data[0].content;
      this.$vs.loading.close();
    },
  },
  computed: {
    confereupload: function () {
      return this.filesPreview;
    },
    carregadoImg() {
      if (this.carregadoIm) {
        return this.content;
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
#page-menu-wrap {
  position: relative !important;
}
.vs-table-text {
  text-align: center;
}
.not-data-table.vs-table--not-data {
  display: none !important;
}
.text-icon {
  span {
    display: block !important;
    text-align: center !important;
  }
  .i-small-xs {
    font-size: 10px !important;
    margin: 0 !important;
    height: 16px !important;
    width: 16px !important;
    line-height: 16px !important;
    float: none !important;
  }
}
.header-table {
  padding: 15px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}
</style>